import React from 'react';

// Colori di stato identici a quelli usati nelle tabelle CCO (emerald / amber / red / slate)
const TONI = {
  ok:     { box: 'bg-emerald-500/10 border-emerald-500/30', testo: 'text-emerald-500', punto: 'bg-emerald-500' },
  warn:   { box: 'bg-amber-500/10 border-amber-500/30',     testo: 'text-amber-500',   punto: 'bg-amber-500' },
  error:  { box: 'bg-red-500/10 border-red-500/30',         testo: 'text-red-500',     punto: 'bg-red-500' },
  neutro: { box: 'bg-slate-400/10 border-slate-400/30',     testo: 'text-slate-400',   punto: 'bg-slate-400' },
  info:   { box: 'bg-primary/10 border-primary/30',         testo: 'text-primary',     punto: 'bg-primary' },
};

const StatusPill = ({ tono = 'neutro', label, pulse = false }) => {
  const t = TONI[tono] ?? TONI.neutro;
  return (
    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-xl border ${t.box}`}>
      <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${t.punto} ${pulse ? 'animate-pulse' : ''}`} />
      <span className={`text-[9px] font-black uppercase tracking-widest whitespace-nowrap ${t.testo}`}>
        {label}
      </span>
    </div>
  );
};

export default StatusPill;
